import { useForm } from '@mantine/form';

import { profileTypes } from '../types';

import { Departments } from '@/types';

type Props = {
  department: Departments;
};

export const useProfileForm = ({ department }: Props) => {
  return useForm<Parameters<profileTypes.AddProfile>[0]>({
    initialValues: {
      name: '',
      department,
      op: 0,
    },

    transformValues: (values) => {
      return {
        ...values,
        op: Number(values.op),
      };
    },

    validate: {
      name: (v) => {
        if (!v) {
          return 'Name is required';
        }
      },
      department: (v) => {
        if (!v) {
          return 'Department is required';
        }
      },
      op: (v) => {
        if (!v) {
          return 'OP is required';
        }
      },
    },
  });
};
